<template>
    <div class="modal-card small_modal floating_frame">
        <section class="floating_frame_container">
            <div class="button_container">
                <SimpleButton @click="choose(3)" :class="['period_button', { 'selected': this.currentPeriod == 3 }]">3
                    meses</SimpleButton>
                <SimpleButton @click="choose(6)" :class="['period_button', { 'selected': this.currentPeriod == 6 }]">6
                    meses</SimpleButton>
                <SimpleButton @click="choose(12)" :class="['period_button', { 'selected': this.currentPeriod == 12 }]">
                    12
                    meses
                </SimpleButton>
                <SimpleButton @click="choose(24)" :class="['period_button', { 'selected': this.currentPeriod == 24 }]">
                    24
                    meses
                </SimpleButton>
                <SimpleButton @click="choose(60)" :class="['period_button', { 'selected': this.currentPeriod == 60 }]">
                    60
                    meses
                </SimpleButton>
                <SimpleButton @click="choose(-1)" :class="['period_button', { 'selected': this.currentPeriod == -1 }]">
                    Toda la data
                </SimpleButton>
            </div>
        </section>
    </div>

</template>


<script>
import SimpleButton from "./SimpleButton.vue";


export default {
    name: "ChangePeriodTimeframe",
    components: {
        SimpleButton,
    },
    data() {
        return {
            how_many_months: '',
        };
    },
    methods: {
        choose(months) {
            if (months > 0) {
                this.$emit('confirm', months)
                return;
            }
            if (months == 0) {
                this.$emit('confirm', this.how_many_months)
                return;
            }
            if (months == -1) {
                this.$emit('confirm', months)
                return;
            }
        }
    },
    props: {
        currentPeriod: Number,
    }
};
</script>

<style scoped>
.floating_frame {
    position: absolute;
    left: 10px;
    z-index: 1000;
    background-color: #eeeeee;
}

.input_months {
    width: 60px;
}

.button_container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
}

.selected {
    background-color: #dddd77;
}

.regular_button {
    position: relative;
    left: 10px;
    margin: 6px;
    width: 110px;
}

.period_button {
    position: relative;
    margin: 4px;
    width: 100px;
}

.small_modal {
    width: 130px;
}
</style>
